// extracted by mini-css-extract-plugin
export default {"list":"index_list_JGDbh","videoCard":"index_videoCard_NYpT-"};